import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=769b92da&scoped=true&"
import script from "./DocumentView.vue?vue&type=script&lang=ts&"
export * from "./DocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=769b92da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b92da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
